import React from 'react';
import { Box, Button, Icon, Spinner, Tooltip } from '@chakra-ui/core';

const DocumentSectionButton = ({ label, completion, onClick }) => {
  const state = completion?.state || 'loading';
  const description =
    state === 'loading' ? 'Chargement de l’état des documents…' : completion.description;
  const background = { complete: 'green.900', pending: 'orange.900' }[state] || 'lightGray3';

  return (
    <Tooltip
      label={description}
      aria-label={description}
      bg="darkGray"
      color="white"
      placement="bottom"
      zIndex="tooltip"
      hasArrow
    >
      <Button
        type="button"
        size="sm"
        variant="outline"
        variantColor="neutral"
        color="white"
        borderColor="rgba(255, 255, 255, 0.65)"
        _hover={{ bg: 'white', color: 'darkGray' }}
        _active={{ bg: 'white', color: 'darkGray' }}
        onClick={onClick}
        aria-label={label}
      >
        {label}
        <Box
          as="span"
          ml={2}
          px={1}
          minW={5}
          h={5}
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          rounded="full"
          bg={background}
          color="darkGray"
          fontSize="xs"
          fontWeight="bold"
          aria-hidden="true"
          data-completion-state={state}
        >
          {state === 'loading' && <Spinner size="xs" />}
          {state === 'unavailable' && '?'}
          {state === 'empty' && '—'}
          {state === 'complete' && <Icon name="check" size={3} mr={1} />}
          {['pending', 'complete'].includes(state) && `${completion.count}/${completion.total}`}
        </Box>
      </Button>
    </Tooltip>
  );
};

export default DocumentSectionButton;
